const log = require('log').create('portfolio', 'image') // eslint-disable-line

/**
 * not sure why i made this diagram
 * +--------------------+
 * | <------width-----> |
 * | ^                  |
 * | |                  |
 * | padding            |
 * | |                  |
 * | v                  |
 * +--------------------+
 *
 * getTargetSize
 * This helper accepts an image with width & height and max width & height and
 * returns an object with the prescribed width and aspect ratio to display the
 * image at its natural width, up to the max width and height given. The width
 * is used in the layout as max-width (so the image is reponsive), and the
 * aspect ratio is used to calculate padding, so the height corresponds to the
 * width available.
 *
 * @param image { width, height } object with image width and height
 * @param max { width, height } object with max width and height
 * @returns target { width, aspect }
 *
 */

function getTargetSize(image, max) {
    const target = {}
    const { width, height } = image

    if (! width || ! height) return

    target.aspect = width / height
    target.width = Math.min(width, max.width)

    // ensure that resulting height isn't taller than prescribed max.height
    const calced_height = target.width / target.aspect
    if (calced_height > max.height) {
        target.width = target.width * (max.height / calced_height)
    }

    return target
}

module.exports = {
    getTargetSize,
}
